import React from 'react'
import { PhoneBox as PSXPhoneBox } from 'fw/forms'

class PhoneBox extends React.PureComponent {
	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { return this.inputBoxValueBuilder(this._input.getValue()) }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { return this._input.validate(); }
	
	render() {
		return (
			<PSXPhoneBox
				{...this.props}
				ref={(i) => this._input = i}
			/>
		)
	}
}

export default PhoneBox;

// Mark this as a form component
PhoneBox.defaultProps = {
	formControl: true,
	managed: false,
	showCountryCode: true,
	types: ["Mobile", "Home", "Office"]
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/phoneBox/PhoneBox.js